<template>
  <article class="accessIndex">
    <div class="accessIndex__reload">
      <v-hover>
        <div
          @click="pagination_query=false;filterUsers(true);date_available=false;"
          slot-scope="{ hover }"
          class="accessIndex__reload--container"
          :class="hover?'accessIndex__interaction--hover':''">
          <img src="../../../../assets/img/reload_blue.svg">
        </div>
      </v-hover>
      <p class="accessIndex__text--title">
        {{!hasAlreadyFilter?'Usuarios en la locación actualmente':'Usuarios en la locación '+dateFormat(filterSearchedDate)+' - '+dateFormat(filterSearchedDate2)}}
      </p>
    </div>
    <div class="accessIndex__general_info--actual_users">
      <!-- <div>
        <label
          class="accessIndex__text--normal_user" style="margin-left:43px">En {{titlelocation}}</label>
      </div> -->
      <section class="trainers__header">
        <div class="trainers__header--title">
          <v-breadcrumbs style="width: 100%">
            <v-icon slot="divider">chevron_right</v-icon>
            <!-- <v-breadcrumbs-item
              @click="$router.push({name: 'access'})">
              Resumen
            </v-breadcrumbs-item> -->
            <v-breadcrumbs-item @click="$router.push({name: 'access_counter_sublocations', params: {id: location_id}})">
              {{ location_name }}
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              disabled>
              Usuarios 
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </div>
      </section>
      <app-date-picker
        v-if="date_available"
        @filterQuery="pagination_query=false;filterUsersByButton($event)"></app-date-picker>
    </div>
    <v-data-table
      :headers="headers"
      :items="accesses"
      :pagination.sync="sorter"
      no-data-text="No se encuentran resultados"
      hide-actions
      class="elevation-1">
      <template
        slot="items"
        slot-scope="props">
        <td>{{ props.item.user }}</td>
        <td>{{ props.item.user_rut }}</td>
        <td>{{ dateFormatText($moment(props.item.in_date).format(" MM/DD/YYYY - h:mm a")) }}</td>
        <td>{{ props.item.out_date != '' ? dateFormatText($moment(props.item.out_date).format(" MM/DD/YYYY - h:mm a")) : '' }}</td>
        <!-- <td>{{ props.item.direction }}</td> -->
        <!-- <td>{{ props.item.site }}</td> -->
      </template>
    </v-data-table>
    <div
      v-if="accesses.length>0&& pages > 1"
      class="accessIndex__pagination">
      <v-pagination
        color="light-blue darken-3"
        v-model="pagination.page"
        :length="pages"></v-pagination>
      <label
        class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
      <label
        class="accessIndex__pagination--current_text"
        v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">
        {{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}
      </label>
      <label
        class="accessIndex__pagination--current_text"
        v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      sorter: {sortBy: 'in_date', descending: true, rowsPerPage: -1},
      saved_default_option:false,
      pagination_query:false,
      date_available:false,
      invitations_size:0,
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      datePickerFirstClick:false,
      hasAlreadyFilter:false,
      filterSearchedDate:new Date().toISOString().substr(0, 10),
      filterSearchedDate2:new Date().toISOString().substr(0, 10),
      initialRender:true,
      pages:2,
      months:["ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC"],
      pagination: {page:1,rowsPerPage:24},
      accesses: [],
      headers: [
        {text:'Usuario', value: 'user'},
        {text:'RUT', value: 'user_rut'},
        {text:'Fecha y hora de ingreso', value: 'in_date'},
        {text:'Fecha y hora de salida', value: 'out_date'}
      ],
      titlelocation:'',
      months_text:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"],
      location_name: '',
      location_id: '',
    }
  },
  watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
       else if(oldVal!=val&&val!=null&&oldVal!=null){
         this.pagination_query=true;
         this.filterUsers(false);

       }

       }
    }
    ,
  methods:{
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    dateFormat(datex){
      var sections=datex.split("-");
      var index=Number(sections[1])-1;
      sections[1]=this.months[index];
      datex=sections.join("/");
      return datex;
    },
    dateFormatText(datex){
        var sections=datex.split("/");
        var index=Number(sections[0])-1;
        sections[0]=this.months_text[index];
        datex=sections.join(" ");
        return datex;
    },
    filterUsersByButton(dates){
      var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' }
      this.date =this.modifyDateFormatToStatus(object.date_from);
      this.date2 =this.modifyDateFormatToStatus(object.date_to);
      if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
        this.datePickerFirstClick=true;
      }
      // alert(this.datePickerFirstClick+this.date+this.date2);
      if(this.datePickerFirstClick){
        this.hasAlreadyFilter=true;
        this.filterSearchedDate=this.date;
        this.filterSearchedDate2=this.date2;
        this.filterUsers(false);
      }

    },
    filterUsers(defaultOption){
      if(this.pagination_query){
        defaultOption=this.saved_default_option;
      }
      else{
        this.pagination.page=1;
      }
      this.saved_default_option=defaultOption;
      //alert(this.$route.params.date+" "+this.$route.params.date2+" "+this.$route.params.filter);
      // var initialDate=new Date().toISOString().substr(0, 10);
      // var lastDate=new Date().toISOString().substr(0, 10);
      var initialDate= ""
      var lastDate=""
      if(!defaultOption){
        initialDate=this.date;
        lastDate=this.date2;
         // initialDate=this.date;
         // lastDate=this.date2;
      }
      else if(this.initialRender&&this.$route.params.filter){
        this.initialRender=false;
        initialDate=this.$route.params.date;
        lastDate=this.$route.params.date2;
        this.date=this.$route.params.date;
        this.date2=this.$route.params.date2;
        this.filterSearchedDate=this.$route.params.date;
        this.filterSearchedDate2=this.$route.params.date2;
        this.datePickerFirstClick=true;
        this.hasAlreadyFilter=true;
        this.saved_default_option=false;
      }
      else{
        this.date= new Date().toISOString().substr(0, 10);
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
        this.hasAlreadyFilter=false;
      }
      try {
        this.$http.get('access/in_out_activity',{
          params:{
            location_id: localStorage.getItem("location_id"),
            offset_time: new Date().getTimezoneOffset(),
            first_date: initialDate,
            last_date: lastDate,
            page:this.pagination.page,
            current:!this.hasAlreadyFilter
          },
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }
        ).then(function(response){
          this.accesses=[];
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // this.accesses = response.body.data;
          var vm =this;
          var temp = response.body.data;

          // str.substring(0, str.length-1) + "-" + str.substring(str.length-1)
          for(var user in temp){
              var rut='';
              if(temp[user]["user_rut"]!=null){
                var rut = temp[user]["user_rut"];
                rut = rut.substring(0, rut.length-1) + "-" + rut.substring(rut.length-1);
              }


                vm.accesses.push({
                  user:temp[user]["user_name"],
                  user_rut:rut,
                  // in_date:this.dateFormatText(this.$moment(temp[user]["date_in"]).format(" MM/DD/YYYY - h:mm a")),
                  in_date:temp[user]["date_in"],

                  // in_date:vm.$moment(temp[user]["date_in"]).format("dddd, MMMM Do YYYY, h:mm:ss a"),
                  out_date: temp[user]["date_out"] != undefined ?
                      // this.dateFormatText(this.$moment(temp[user]["date_out"]).format(" MM/DD/YYYY - h:mm a")) : ""
                      temp[user]["date_out"] : ""

                })
          }
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          /* console.table(vm.accesses); */
          this.loaded = true;
          this.date_available=true;
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
                vm.updateAlertMessage(response.body.data.message)
                vm.updateIsInAlert(true)
              }else{
                alert(response.body.data.messages)
              }
          }else{
            if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
                vm.updateAlertMessage(response.body.data)
                vm.updateIsInAlert(true)
            }else{
              alert(response.body.data)
            }
          }
        })
      } catch (e) {
        if(navigator.userAgent=="Comfamiliar-Gimnasios-Desktop-App"){
            this.updateAlertMessage(e.message)
            this.updateIsInAlert(true)
        }else{
          alert(e.message)
        }
      }
    }
  },
  mounted(){
    this.location_name = this.$route.params.location_name;
    this.filterUsers(true);
    this.location_id = this.$route.params.id;
    this.titlelocation=this.$route.params.namex;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/CounterLocation.vue